import { supabase } from '../../common/config/supabase';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';
import { ICertificateTemplate } from '../../common/interfaces/certificate-template.interface';

export const getCertificateTemplateByCompanyId = async (
  companyId: string,
): Promise<ICertificateTemplate> => {
  const { data, error } = await supabase
    .from('certificate_template')
    .select('*')
    .eq('company_id', companyId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateOrCreateCertificateTemplate = async (
  companyId: string,
  config: PDFStaticBuilderProps,
): Promise<ICertificateTemplate> => {
  const { data, error } = await supabase
    .from('certificate_template')
    .upsert({ company_id: companyId, config }, { onConflict: 'company_id' })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
